import { pushToDataLayer } from "../data/data-layer.facade";
import { attachClickEventListener, getBusinessUnit } from "@shared/Utils/analytics-utils";
import { getHeadingOfLink } from "./link-click-analytics";

export type GA4FrontPageEvent = {
  event: "frontpage_tracking";
  element_category: string;
  element_cta: string;
  element_description: string;
  element_url: string;
  business_unit: "B2C" | "B2B";
  index: number;
};

const SECTION_DATA_IDS = ["forside-banner", "hurtig-valg", "Snarveier", "aktuelt", "Mer data"];

export const bootstrapFrontPageAnalytics = () => {
  SECTION_DATA_IDS.forEach((sectionDataId, index) => {
    const elements = document.querySelectorAll(`[data-id='${sectionDataId}'] a`);

    attachClickEventListener(elements, (e) => {
      const target = e.target as HTMLElement;
      const targetA = target.closest<HTMLAnchorElement>("a");
      const cta = targetA?.dataset.titleText ?? targetA?.innerText ?? "";
      const elementDescription = getHeadingOfLink(targetA as HTMLElement);

      const linkUrl = targetA?.href ?? "";

      const event: GA4FrontPageEvent = {
        event: "frontpage_tracking",
        element_category: sectionDataId,
        element_cta: cta,
        element_description: elementDescription,
        element_url: linkUrl,
        business_unit: getBusinessUnit(),
        index: index,
      };

      pushToDataLayer(event);
    });
  });
};

const buildingSectionDataIds = SECTION_DATA_IDS.map((id) => `[data-id='${id}']`).join(", ");

export const AddOfferingButtonFrontPageTracking = (
  button: HTMLButtonElement,
  buttonText: string,
  buttonDescription: string,
) => {
  const shouldSendFrontPageEvent = button.closest(buildingSectionDataIds);
  if (!shouldSendFrontPageEvent) return;

  const event: GA4FrontPageEvent = {
    event: "frontpage_tracking",
    element_category: shouldSendFrontPageEvent.getAttribute("data-id") || "",
    element_cta: buttonText,
    element_description: buttonDescription,
    element_url: "no-url-add-to-cart-button",
    business_unit: getBusinessUnit(),
    index: 0,
  };
  pushToDataLayer(event);
};
